import { AgentMarkIcon } from "@v1/ui/agent-mark-icon";
import {
  Clock,
  Code2,
  Coins,
  Database,
  Globe,
  Inbox,
  Plug,
  Rocket,
  Shield,
  Sparkles,
  TrendingUp,
  Users,
} from "lucide-react";
import type { ReactElement } from "react";
import type { FunnelIconKey } from "./developers-funnel-content";

const LUCIDE_ICONS = {
  inbox: Inbox,
  plug: Plug,
  globe: Globe,
  shield: Shield,
  clock: Clock,
  coins: Coins,
  rocket: Rocket,
  users: Users,
  code: Code2,
  database: Database,
  sparkles: Sparkles,
  "trending-up": TrendingUp,
} as const;

/**
 * Renders the icon behind a bullet's `icon` key.
 * Agents use the brand triangle; everything else is Lucide.
 */
export function FunnelIcon({
  name,
  size = 20,
}: {
  readonly name: FunnelIconKey;
  readonly size?: number;
}): ReactElement {
  if (name === "agent") {
    return <AgentMarkIcon size={size} proportionalCorners />;
  }

  const Icon = LUCIDE_ICONS[name];
  return <Icon size={size} strokeWidth={1.9} aria-hidden={true} />;
}
